import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

interface LoadingProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  fullPage?: boolean;
  className?: string;
}

/**
 * Reusable loading spinner with optional message
 */
export function Loading({ size = 'medium', message, fullPage = false, className }: LoadingProps) {
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-8 w-8',
    large: 'h-12 w-12',
  } as const;

  const spinner = (
    <Loader2 className={cn(sizeClasses[size], 'animate-spin text-gray-500 dark:text-gray-400', className)} />
  );

  if (fullPage) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="flex flex-col items-center">
          {spinner}
          {message && <p className="mt-4 text-gray-600 dark:text-gray-400">{message}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center">
      {spinner}
      {message && <p className="mt-2 text-gray-500 dark:text-gray-400 text-sm">{message}</p>}
    </div>
  );
}
